
import { Model, RightTab, UICommandType, UserData, TTMsg, Msg } from "../Model/ModelType.js";
import { replace, concat, join } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { empty, isEmpty, singleton, filter, map } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { choicePopup } from "../DrawBlock/PopupHelpers.js";
import * as react from "react";
import { sweepUnusedLibrarySheets, saveOpenFileActionWithModelUpdate, openProjectFromPath, setupProjectFromComponents, warnAppWidth } from "./MenuHelpers.js";
import { clearBrowserStoredPath, readFilesFromDirectory, askForExistingProjectPathAsync, persistFileToExternalStorageAsync, writeFile, baseName, pathJoin, tryCreateFolder, askForNewProjectPathAsync } from "../Interface/FilesIO.js";
import { displayAlertOnError } from "./Notifications.js";
import { showDemoProjects, addFileToProject, createEmptyComponentAndFile } from "./TopMenuView.js";
import { error } from "../Shared/Log.js";
import { DrawModelType_SheetT_Model__Model_ClearCanvas_7D5C5FDA } from "../DrawBlock/Sheet.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { importSheet } from "./MiscMenuView.js";
import { Exception } from "../fable_modules/fable-library-js.5.13.0/Util.js";

/**
 * force either save of current file before action, or abort (closeProject is special case of this)
 * In addition, if not aborting, save current lockstate of all files.
 */
export function doActionWithSaveFileDialog(name, nextAction, model, dispatch, _arg) {
    let children_2;
    const closeDialogButtons = (keepOpen, _arg_1) => {
        if (keepOpen) {
            dispatch(Msg.ClosePopup);
        }
        else {
            dispatch(nextAction);
        }
    };
    let sheetsNeedingSave;
    const matchValue = model.CurrentProj;
    sheetsNeedingSave = ((matchValue != null) ? join(",", map((c_1) => c_1.Name, filter((c) => c.LoadedComponentIsOutOfDate, matchValue.LoadedComponents))) : "");
    if (model.SavedSheetIsOutOfDate) {
        choicePopup(concat(name, "?"), react.createElement("div", {}, "The current sheet has unsaved changes."), "Go back to sheet", concat(name, " without saving changes"), closeDialogButtons, dispatch);
    }
    else if (sheetsNeedingSave !== "") {
        choicePopup("Do you want to close without saving?", (children_2 = [concat("The sheets ", sheetsNeedingSave, " have unsaved changes.")], react.createElement("div", {}, ...children_2)), "Go back to sheet", concat(name, " without saving changes"), closeDialogButtons, dispatch);
    }
    else {
        dispatch(nextAction);
    }
}

function newProject(model, dispatch) {
    warnAppWidth(dispatch, () => {
        const pr_2 = askForNewProjectPathAsync(model.UserData.LastUsedDirectory);
        void (pr_2.then((_arg_1) => {
            if (_arg_1 != null) {
                const path = _arg_1;
                const matchValue = tryCreateFolder(path);
                if (matchValue.tag === 0) {
                    dispatch(Msg.EndSimulation);
                    dispatch(new Msg(/* TruthTableMsg */ 32, [TTMsg.CloseTruthTable]));
                    dispatch(Msg.EndWaveSim);
                    const projectFilePath = pathJoin([path, baseName(path) + ".dprj"]);
                    displayAlertOnError(dispatch, writeFile(projectFilePath, ""));
                    const initialComponent = createEmptyComponentAndFile(path, "main");
                    let pr_1;
                    const pr = persistFileToExternalStorageAsync(projectFilePath);
                    pr_1 = (pr.then(() => persistFileToExternalStorageAsync(initialComponent.FilePath)));
                    void (pr_1.then(() => {
                        let bind$0040;
                        dispatch(new Msg(/* SetUserData */ 113, [(bind$0040 = model.UserData, new UserData(bind$0040.UserAppDir, path, bind$0040.RecentProjects, bind$0040.ArrowDisplay, bind$0040.WireType, bind$0040.Theme))]));
                        setupProjectFromComponents(false, "main", singleton(initialComponent), model, dispatch);
                    }).catch((err_1) => {
                        alert(concat("Create project failed\n\n", err_1.message));
                    }));
                }
                else {
                    const err = matchValue.fields[0];
                    error(err);
                    alert(concat("Invalid Project Name\n\n", err));
                    newProject(model, dispatch);
                }
            }
        }).catch((err_2) => {
            alert(concat("Create project failed\n\n", err_2.message));
        }));
    });
}

function openProject(model, dispatch) {
    warnAppWidth(dispatch, () => {
        let matchValue, option;
        const pr = askForExistingProjectPathAsync((matchValue = ((option = model.UserData.LastUsedDirectory, (option != null) ? readFilesFromDirectory(option) : undefined)), (matchValue == null) ? undefined : (isEmpty(matchValue) ? undefined : model.UserData.LastUsedDirectory)));
        void (pr.then((_arg_1) => {
            if (_arg_1 != null) {
                openProjectFromPath(_arg_1, model, dispatch);
            }
        }).catch((err) => {
            alert(concat("Open project failed\n\n", err.message));
        }));
    });
}

function isDemoProjectPath(path) {
    return replace(path, "\\", "/").indexOf("/demos/") >= 0;
}

export function forceCloseProject(model, dispatch) {
    let option_5;
    let option_3;
    const option_1 = model.CurrentProj;
    option_3 = ((option_1 != null) ? option_1.ProjectPath : undefined);
    option_5 = ((option_3 != null) ? (isDemoProjectPath(option_3) ? option_3 : undefined) : undefined);
    if (option_5 != null) {
        clearBrowserStoredPath(option_5);
    }
    dispatch(new Msg(/* StartUICmd */ 109, [UICommandType.CloseProject]));
    dispatch(Msg.EndSimulation);
    dispatch(new Msg(/* TruthTableMsg */ 32, [TTMsg.CloseTruthTable]));
    dispatch(Msg.EndSimulation);
    dispatch(Msg.EndWaveSim);
    DrawModelType_SheetT_Model__Model_ClearCanvas_7D5C5FDA(model.Sheet, (sMsg) => {
        dispatch(new Msg(/* Sheet */ 3, [sMsg]));
    });
    dispatch(new Msg(/* UpdateModel */ 41, [(model_1) => (new Model(model_1.WindowWidth, model_1.KeyFocusPane, model_1.RunAfterRenderWithSpinner, model_1.UserData, model_1.WaveSim, model_1.WaveSimSheet, model_1.UISheetTrail, model_1.Spinner, model_1.Sheet, model_1.IsLoading, model_1.LastChangeCheckTime, model_1.LastSimulatedCanvasState, model_1.LastDetailedSavedState, model_1.CurrentSelected, model_1.LastSelectedIds, model_1.LastUsedDialogWidth, model_1.SelectedComponent, model_1.CurrentStepSimulationStep, model_1.CurrentTruthTable, model_1.TTConfig, RightTab.Properties, model_1.SimSubTabVisible, model_1.CircuitCheck, model_1.Hilighted, model_1.Clipboard, model_1.LastCreatedComponent, model_1.SavedSheetIsOutOfDate, model_1.PendingDragAddition, model_1.DragPlacement, model_1.ProjectBrowser, model_1.TopSheetChoiceDeclined, model_1.ComponentLibraries, model_1.OpenLibrary, model_1.CatalogueSearch, model_1.ArrayCopiesTyped, model_1.SimulateInRenderer, model_1.SidecarSession, model_1.ProbeRead, model_1.SidecarInFlight, model_1.SidecarBuildEndedMs, model_1.SidecarRunEndedMs, model_1.StepRunTarget, model_1.FetchedData, model_1.FetchedStructure, model_1.FailedFetch, model_1.StimulusGeneration, model_1.CurrentViewport, model_1.ViewportChangedAtMs, model_1.WaveScrollSettling, model_1.WaveScrollSerial, model_1.ShowLibrarySheets, model_1.SuppressErrorPopups, model_1.OpenedLibrarySheets, model_1.ReadOnlyBaseline, model_1.CurrentProj, model_1.PopupViewFunc, model_1.SpinnerPayload, model_1.PopupDialogData, model_1.Notifications, model_1.TopMenuOpenState, model_1.SheetMenuPinned, model_1.DividerDragMode, model_1.WaveSimViewerWidth, model_1.ConnsOfSelectedWavesAreHighlighted, empty(), model_1.UIState, model_1.BuildVisible, model_1.CodeEditorState))]));
    dispatch(Msg.FinishUICmd);
}

export function activateBrowserSelection(_model, _dispatch) {
}

/**
 * Implement a command involving file operations from Update, with access to dispatch
 * Invoked by message: `FileCommand(fc,dispatch)`.
 * TODO - refactor to remove dispatch dependence
 */
export function fileCommand(fc, dispatch, model) {
    switch (fc.tag) {
        case 5: {
            addFileToProject(model, dispatch);
            return [model, Cmd_none()];
        }
        case 0: {
            importSheet(model, dispatch);
            return [model, Cmd_none()];
        }
        case 1: {
            if (fc.fields[0]) {
                doActionWithSaveFileDialog("New project", new Msg(/* ExecFuncInMessage */ 116, [(model_1, dispatch_1) => {
                    newProject(model_1, dispatch_1);
                }, dispatch]), model, dispatch, undefined);
            }
            else {
                newProject(model, dispatch);
            }
            return [model, Cmd_none()];
        }
        case 2: {
            if (fc.fields[0]) {
                doActionWithSaveFileDialog("Open project", new Msg(/* ExecFuncInMessage */ 116, [(model_2, dispatch_2) => {
                    openProject(model_2, dispatch_2);
                }, dispatch]), model, dispatch, undefined);
            }
            else {
                openProject(model, dispatch);
            }
            return [model, Cmd_none()];
        }
        case 3: {
            doActionWithSaveFileDialog("Close project", new Msg(/* ExecFuncInMessage */ 116, [(model_3, dispatch_3) => {
                forceCloseProject(model_3, dispatch_3);
            }, dispatch]), model, dispatch, undefined);
            return [model, Cmd_none()];
        }
        case 4: {
            saveOpenFileActionWithModelUpdate(model, dispatch);
            dispatch(new Msg(/* UpdateModel */ 41, [sweepUnusedLibrarySheets]));
            return [model, Cmd_none()];
        }
        case 6: {
            showDemoProjects(model, dispatch, fc.fields[0]);
            return [model, Cmd_none()];
        }
        default:
            throw new Exception("Match failure: ModelType.FileCommandType");
    }
}

